'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentHelper = require('./component-helper');

var _translatorType = require('./translatorType');

var _translatorType2 = _interopRequireDefault(_translatorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provide the translator for the whole application.
 * @param Object translator           Translator object
 * @param Component WrappedComponent  A wrapper component
 * @return Component
 */
var provideTranslate = function provideTranslate(translator) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      (0, _inherits3.default)(ProviderTranslate, _React$Component);

      function ProviderTranslate() {
        (0, _classCallCheck3.default)(this, ProviderTranslate);
        return (0, _possibleConstructorReturn3.default)(this, (ProviderTranslate.__proto__ || (0, _getPrototypeOf2.default)(ProviderTranslate)).apply(this, arguments));
      }

      (0, _createClass3.default)(ProviderTranslate, [{
        key: 'getChildContext',


        /**
         * `translator` is an object with functions declared in
         * `childContextTypes`.
         */
        value: function getChildContext() {
          return { translator: translator };
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }], [{
        key: 'preFetch',
        value: function preFetch(props) {
          props.res.locals = (0, _extends3.default)({}, props.res.locals, {
            translator: translator
          });

          // Call child preFetch if any
          var wrappedPreFetch = (0, _componentHelper.getDataDependency)(WrappedComponent, 'preFetch');
          if (!wrappedPreFetch) {
            return _promise2.default.resolve();
          }
          return wrappedPreFetch(props);
        }
      }]);
      return ProviderTranslate;
    }(_react2.default.Component), _class.childContextTypes = {
      translator: _translatorType2.default
    }, _class.WrappedComponent = WrappedComponent, _class.displayName = 'ProviderTranslate(' + (0, _componentHelper.getDisplayName)(WrappedComponent) + ')', _temp;
  };
}; /* eslint no-param-reassign: 0 */

exports.default = provideTranslate;


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/react/provideTranslate.js
// module id = 513
// module chunks = 0